export default "__VITE_ASSET__CJgDoON$__"